module.exports = __webpack_public_path__ + "roboto-latin-300-normal.c48fb6765a9fcb00b3300fee318b45df.hashedasset.woff2";